
<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="Service / Package" [backWithParams]="true">
  <ng-template #addButton>
    
    <div class="d-flex search-field service_se" *ngIf="isOwner">
      <div class="create_btn_sd" >
        <button mat-icon-button color="primary" aria-label="option menu" [matMenuTriggerFor]="menu">
            <mat-icon>add</mat-icon> 
        </button>
    </div>
      <mat-menu #menu="matMenu">
        <button  mat-menu-item (click)="onCreateNewService()">
          <mat-icon class="material-icons-outlined">add</mat-icon>
          <span>{{ 'services.manual_service' | translate }}</span>
        </button>
        <button  mat-menu-item (click)="onCreateNewServiceFromTemplate()">
          <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
          <span>{{ 'services.template_service' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </ng-template>
</sm-title-bar>
<!-- <div class="chip_cont">
  <mat-chip-list aria-label="Fish selection" class="mb-3">
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '0' }"
      (click)="changeChip('0')"
      >{{ 'services.home_service' | translate }}
    </mat-chip>
  </mat-chip-list>

  <mat-chip-list aria-label="Fish selection" class="mb-3">
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '1' }"
      (click)="changeChip('1')"
      >{{ 'services.shop_service' | translate }}
    </mat-chip>
  </mat-chip-list>
</div> -->
<div class="search_sect">
<mat-form-field appearance="outline" class="me-2">
  <mat-label>{{ 'services.label' | translate }}</mat-label>
  <input
  [formControl]="searchString"
   
    matInput
    placeholder="{{ 'services.placeholder' | translate }}"
  (keyup)="searchServiceData()"
  />
  <button
    mat-button
    *ngIf="!searchString.value"
    matSuffix
    aria-label="Clear"
  >
    <mat-icon>search</mat-icon>
  </button>
  <button
  mat-button
  *ngIf="searchString.value"
  matSuffix
  aria-label="Clear"
  (click)="reset()"
>
  <mat-icon>close</mat-icon>
</button>
</mat-form-field>

</div>
<!-- 

<mat-card *ngIf="!loader">
  <mat-card-header class="justify-content-between align-items-center mb-3">
    
     </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="serviceList" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
       [showPagination]="false" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="5">
    </sm-data-table>
  </div>
</mat-card> -->
<div class="service_card_sedf" *ngIf="serviceList.length > 0 && !loader">
  <div class="row">
      <div class="col-sm-6" *ngFor="let item of serviceList">
          <div class="serv_sect">
      <mat-card appearance="outlined" class="service-card">
        <mat-card-header class="hy_secf">
          <div mat-card-avatar class="header-avatar">
              <div class="red_dot_ser" *ngIf="item.status == 7"></div>
              <div class="green_dot_ser" *ngIf="item.status == 1"></div>
              <img [src]="item.imgUrl" *ngIf="item.imgUrl && item.imgUrl != 'null'" onerror="this.src='../../../../assets/images/salon_support_header.png'" alt="Service image">
              <div class="booking-initial" *ngIf="!item.imgUrl || item.imgUrl == 'null'">{{item.serviceName.slice(0,1).toUpperCase()}}</div>
            </div>
          <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options" *ngIf="isOwner">
              <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu2="matMenu">
              <button mat-menu-item (click)="onEdit(item)">
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                  <span>Edit</span>
              </button>
              <button mat-menu-item (click)="changeStatus(item,1)" *ngIf="item.status == 7">
                  <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                  <span>Activate</span>
              </button>
              <button mat-menu-item (click)="changeStatus(item,7)" *ngIf="item.status == 1">
                  <mat-icon class="material-icons-outlined">unpublished</mat-icon>
                  <span>Deactivate</span>
              </button>
              <button mat-menu-item (click)="deleteService(item)">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete</span>
              </button>
          </mat-menu>
          
      </mat-card-header>
      <mat-card-content>
          <div class="header_ftgt">
              <mat-card-title>{{item.serviceName}}</mat-card-title>
              <mat-card-subtitle>{{item.service_type}} | {{item.approxTime}} Min</mat-card-subtitle>
          </div>
          <div class="rates" *ngIf="!item.discountStatus || item.discountStatus == null || item.discountStatus == 0">
              <div class="rate-item" *ngIf="item.home_rate != '-'">
                  <span class="rate-label">Home Rate</span>
                
                  <span class="rate-value" *ngIf="item.homeDiscountedPrice == '-'">
                      <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                  </span>
              </div>
              <div class="rate-item" *ngIf="item.shop_rate != '-'">
                  <span class="rate-label">Shop Rate</span>
                  
                  <span class="rate-value" *ngIf="item.shopDiscountedPrice == '-'">
                      <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                  </span>
              </div>
              <div class="rate-item" *ngIf="item.virtual_rate != '-'">
                <span class="rate-label">Virtual Rate</span>
               
                <span class="rate-value" *ngIf="item.virtual_discounted_amount == '-'">
                    <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                    <span class="discounted-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                </span>
            </div>
          </div>
          <div class="" *ngIf="item.discountStatus && item.discountStatus != null && item.discountStatus != 'null' && item.discountStatus == 1">
              <div class="rate-item" *ngIf="item.home_rate != '-'">
                  <span class="rate-label">Home Rate</span>
                  <span class="rate-value" *ngIf="item.homeDiscountedPrice != '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.homeDiscountedPrice.toFixed(2)}}</span>
                  </span>
                  <span class="rate-value" *ngIf="item.homeDiscountedPrice == '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                  </span>
                
              </div>
              <div class="rate-item" *ngIf="item.shop_rate != '-'">
                  <span class="rate-label">Shop Rate</span>
                  <span class="rate-value" *ngIf="item.shopDiscountedPrice != '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.shopDiscountedPrice.toFixed(2)}}</span>
                  </span>
                  <span class="rate-value" *ngIf="item.shopDiscountedPrice == '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                  </span>
                  
              </div>
              <div class="rate-item" *ngIf="item.virtual_rate != '-'">
                <span class="rate-label">Virtual Rate</span>
                <span class="rate-value" *ngIf="item.virtual_discounted_amount != '-'">
                    <span class="original-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                    <span class="discounted-rate">{{item.currency_symbol}}{{item.virtual_discounted_amount.toFixed(2)}}</span>
                </span>
                <span class="rate-value" *ngIf="item.virtual_discounted_amount == '-'">
                    <span class="original-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                    <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                </span>
               
            </div>
          </div>
          <!-- <p class="description">
              {{item.description | ellipsify: 80}}
          </p> -->
      </mat-card-content>

  </mat-card>
</div>
</div>



<!--  -->




</div>
</div>
<div class="placeholder_started" *ngIf="serviceList.length == 0 && !loader">
  <div class="row">
    <!-- <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card>
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/placeholder-service.avif">
           </div>
           <mat-card-title>Contrary to popular belief, Lorem Ipsum is not simply  text.</mat-card-title>
           <mat-card-content>The built-in and extensible SEO tools ensures your store is found first when a shopper is looking to make a purchase.
          </mat-card-content>
           <div class="create_btnyh">
              <button mat-flat-button color="primary">
                  <mat-icon>add</mat-icon> 
                  Create new
              </button>
           </div>
           </div>
        </mat-card>
     </div>
    </div> -->
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/service-list-01.jpg">
           </div>
           <mat-card-title>No service to show
          </mat-card-title>
           <mat-card-content>All the services offered by your business will appear here with all details. Start adding one now.
          </mat-card-content>
           <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu" *ngIf="isOwner">
                 <mat-icon>add</mat-icon>
                Add service
              </button>
              <mat-menu #menu="matMenu">
                <button  mat-menu-item (click)="onCreateNewService()">
                  <mat-icon class="material-icons-outlined">add</mat-icon>
                  <span>{{ 'services.manual_service' | translate }}</span>
                </button>
                <button  mat-menu-item (click)="onCreateNewServiceFromTemplate()">
                  <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
                  <span>{{ 'services.template_service' | translate }}</span>
                </button>
               
              </mat-menu>
           </div>
           </div>
        </mat-card>
     </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/add-service.png">
           </div>
           <mat-card-title>How to add service?</mat-card-title>
           <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')">help document</span> on creating services against a business. You can check this video as well.
          </mat-card-content>
           <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                 <mat-icon>play_arrow</mat-icon>
                 Watch video
              </button>
           </div>
           </div>
        </mat-card>
     </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/helpsupport.png">
           </div>
           <mat-card-title>Having any issue?</mat-card-title>
           <mat-card-content>For any difficulties in adding service or in getting the template list, contact our support team.
          </mat-card-content>
           <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="opencontact()">
                 <mat-icon>support_agent</mat-icon>
                 Contact support
              </button>
           </div>
           </div>
        </mat-card>
     </div>
    </div>
  </div>

</div>

<mat-paginator
*ngIf="!loader && serviceList.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>

